module.exports = __webpack_public_path__ + "static/img/ups-battery-01@w.80c1ea5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/ups-battery-01@w.jpg
// module id = p3Xl
// module chunks = 0